import $ from 'jquery';
import Cookie from '../cookie';
import target from './target';

function validate() {
	const $form = $('.oc-form, .oc-light-form');
	let valid = true;

	$form.find('.oc-light-form__captcha').removeClass('oc-light-form-field_error');

	$form.find('input[type="checkbox"]').each(function () {
		const $this = $(this);
		$this.closest('.oc-light-form-field').removeClass('oc-light-form-field_error');
		if ($this.prop('required')) {
			if (!$this.is(':checked')) {
				$this.closest('.oc-light-form-field').addClass('oc-light-form-field_error');
				valid = false;
			}
		}
	});
	$form.find('.oc-form__control, .oc-light-form-input-text, .oc-light-form-textarea, select.oc-light-form-select').each(function () {
		const $this = $(this);
		$this.closest('.oc-form__field').removeClass('oc-form__control_validate');
		$this.closest('.oc-light-form-field').removeClass('oc-light-form-field_error');
		if ($this.prop('required')) {
			if ($this.val() == '') {
				$this.closest('.oc-form__field').addClass('oc-form__control_validate');
				$this.closest('.oc-light-form-field').addClass('oc-light-form-field_error');
				valid = false;
			}
		}
	});

	return valid;
}

const success = (result) => {
	target();
	const $modal = $('.oc-modal');
	$modal.addClass('success').removeClass('error');
	$('.oc-light-form').removeClass('oc-light-form_error').addClass('oc-light-form_success');
	$('#oc-result-zagl, .oc-light-form__result-header').html('Ваша заявка успешно отправлена');
	$('#oc-result-content, .oc-light-form__result-content').html(result);
	$('.oc-form__result, .oc-light-form__result').show();
	$('#oc-modal-content, .oc-light-form__content').hide();
};

const fail = (result) => {
	result = result || '';
	target('error');
	const $modal = $('.oc-modal');
	$modal.addClass('error').removeClass('success');
	$('.oc-light-form').addClass('oc-light-form_error').removeClass('oc-light-form_success');
	$('#oc-result-zagl, .oc-light-form__result-header').html('Ошибка');
	$('#oc-result-content, .oc-light-form__result-content').html(result);
	$('.oc-form__result, .oc-light-form__result').show();
	$('#oc-modal-content, .oc-light-form__content').hide();
};

const sendData = (data, success, fail) => {
	const _csrf = Cookie.get('_csrf');
	const url = document.location.href;

	const timezone = -(+(new Date()).getTimezoneOffset() / 60);

	$.ajax({
		url: window.shopOrdercallConfig.action,
		method: 'post',
		data: `_csrf=${_csrf}&url=${url}&timezone=${timezone}&` + data
	}).done(function (r) {
		success(r);
	}).fail(function () {
		fail();
	});
};

function send() {
	if (!this.validate()) {
		return false;
	}
	const $form = $('.oc-form, .oc-light-form');

	sendData($form.serialize(), (r) => {
		if (r.status === 'fail' || r.errors != undefined) {
			if (r.errors[0] === 'Captcha not valid') {
				$form.find('.oc-light-form__not-valid-captcha').text('Капча не валидна!');
				$('.wa-captcha-refresh').click();

				if ($form.find('.wa-recaptcha, .wa-captcha').length > 0) {
					$form.find('.oc-light-form__captcha').addClass('oc-light-form-field_error');
				}

				return;
			}
			if (r.errors[0] === 'Already exist') {
				fail('Вы уже отправляли заявку');
				return;
			}
			fail();
			return;
		}
		success(r.data);
	}, () => {
		fail();
	});

	return true;
}

function fillOrdercallUserSpecifiedFields () {
	const data = window.wa_ordercall_userdata;
	if (data) {
		if (data.wa_captcha) {
			$('.ordercall-add-captcha').prepend(data.wa_captcha);
		}
		if (data.wa_user_email) {
			$('.ordercall-insert-email').val(data.wa_user_email);
		}
		if (data.wa_user_name) {
			$('.ordercall-insert-name').val(data.wa_user_name);
		}
		if (data.wa_user_phone) {
			let phone = $('.ordercall-insert-phone');
			phone.val(data.wa_user_phone);
			phone.trigger('input');
		}
	}

}


export default {
	validate,
	sendData,
	send,
	success,
	fail,
	fillOrdercallUserSpecifiedFields
};


// WEBPACK FOOTER //
// ./src/webpack/frontend/ordercall/Form.js